
import { defineComponent } from 'vue';
import { IHost, IServiceCode } from '@/types/models';
import api from '@/api/admin/serviceCodes';
import utils from '@/utils';
import { IElForm } from '@/types/element';

interface IUpdateImageForm {
  id: number;
  code: string;
}

interface IState {
  serviceCodeType: string;
  serviceCodes: IServiceCode[];
  isSendOutForm: boolean;
  sendOutForm: IUpdateImageForm;
}

export default defineComponent({
  data() {
    return {
      serviceCodeType: 'Apply',
      serviceCodes: [],
      isSendOutForm: false,
      sendOutForm: {} as IUpdateImageForm,
    } as IState;
  },
  methods: {
    apiGet() {
      const isSendOut = this.serviceCodeType === 'SendOut';
      api.get({ isSendOut }, (res) => {
        this.serviceCodes = res.serviceCodes;
      });
    },

    getUrl(host: IHost): string {
      return utils.getHostUrl(host.hostName, host.nodeName, host.isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    btnNavClick() {
      this.apiGet();
    },

    btnSendOutClick(serviceCode: IServiceCode) {
      this.sendOutForm.id = serviceCode.id;
      this.sendOutForm.code = '';
      this.isSendOutForm = true;
    },

    btnSendOutSubmitClick() {
      (this.$refs.sendOutForm as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.sendOutForm, (res) => {
            if (!res) return;
            this.isSendOutForm = false;
            this.apiGet();
            utils.success('服务码发送成功');
          });
        }
      });
    },

    btnDeleteClick(serviceCode: IServiceCode) {
      utils.alertDelete(
        {
          title: '删除服务码',
          text: `此操作将删除服务码 ${serviceCode.code || serviceCode.id}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(serviceCode.id, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('服务码删除成功');
          });
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
